module.exports = __webpack_public_path__ + "static/media/banco-do-brasil-azul.8ac731d6.webp";